import { useMutation } from "react-query";
import downloadNoteSkuRepayment from "../services/downloadNoteSkuRepayment";

function useDownloadNoteSkuRepayment() {
  return useMutation(["download-repayment"], downloadNoteSkuRepayment);
}

export default useDownloadNoteSkuRepayment;
